enum LabelConstants {
  GET_LABELS_LIST = "GET_LABELS_LIST",
  GET_LABELS_LIST_SUCCESS = "GET_LABELS_LIST_SUCCESS",
  GET_LABELS_LIST_FAILURE = "GET_LABELS_LIST_FAILURE",

  ADD_LABEL_REQ = "ADD_LABEL_REQ",
  ADD_LABEL_SUCCESS = "ADD_LABEL_SUCCESS",
  ADD_LABEL_FAILURE = "ADD_LABEL_FAILURE",

  EDIT_LABEL_REQUEST = "EDIT_LABEL_REQUEST",
  EDIT_LABEL_SUCCESS = "EDIT_LABEL_SUCCESS",
  EDIT_LABEL_FAILURE = "EDIT_LABEL_FAILURE",

  DELETE_LABEL_REQUEST = "DELETE_LABEL_REQUEST",
  DELETE_LABEL_SUCCESS = "DELETE_LABEL_SUCCESS",
  DELETE_LABEL_FAILURE = "DELETE_LABEL_FAILURE",

  NULLIFY_NEW_LABEL = "NULLIFY_NEW_LABEL",

  RESET_LABELS = "RESET_LABELS",
}

export default LabelConstants;
